/* Daza Organic · «Nuestra historia»: los textos en la cursiva de marca se
   revelan de izquierda a derecha cuando entran en pantalla —da la
   sensación de un trazo escribiéndose, aprovechando que la cursiva ya
   viene conectada—. Toda la animación es CSS (clip-path en daza-
   relato.css); este script solo pone la clase que la dispara, una vez, vía
   IntersectionObserver. Sin JS o sin soporte de IntersectionObserver el
   texto ya está completo en el HTML —solo se ve sin el barrido—.

   Dos casos, mismo mecanismo:
   - Las palabras en énfasis de la cita (*asteriscos* en el texto, ver
     sections/daza-relato.liquid), disparadas cuando la CITA entra en
     pantalla.
   - El título y la firma de la carta de Sandra, disparados cuando la
     CARTA entra en pantalla (la firma un poco después por CSS
     transition-delay, para que se lean como dos trazos seguidos). */
(function () {
  'use strict';

  function iniciar() {
    var nodos = document.querySelectorAll(
      '.s-relato__cita-enfasis:not([data-listo]), ' +
      '.s-relato__carta-titulo:not([data-listo]), ' +
      '.s-relato__carta-firma:not([data-listo])'
    );
    if (!nodos.length) return;

    var soportado = 'IntersectionObserver' in window;

    nodos.forEach(function (nodo) {
      nodo.dataset.listo = '1';

      if (!soportado) {
        nodo.classList.add('es-visible');
        return;
      }

      var contenedor = nodo.closest('.s-relato__cita, .s-relato__carta, .s-relato__cierre');
      if (!contenedor) {
        nodo.classList.add('es-visible');
        return;
      }

      var observer = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          observer.disconnect();
          nodo.classList.add('es-visible');
        });
      }, { threshold: 0.4 });
      observer.observe(contenedor);
    });
  }

  /* Escritura de la carta: cada verso (lo que iba entre <br>) pasa a ser un
     bloque con su propio retraso, en orden de lectura. Las columnas CSS
     reparten los <p> de arriba abajo y luego de izquierda a derecha, que es
     el mismo orden del DOM, así que basta con recorrerlos en secuencia. */
  var PAUSA_VERSO = 0.06;
  var PAUSA_ESTROFA = 0.1;
  var INICIO = 0.5; // el título de la carta tarda 0,6 s: los versos arrancan casi al terminar

  function escribirCarta() {
    var cartas = document.querySelectorAll('.s-relato__carta:not([data-escrita])');
    if (!cartas.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var soportado = 'IntersectionObserver' in window;

    cartas.forEach(function (carta) {
      carta.dataset.escrita = '1';
      if (reduce || !soportado) return;

      var estrofas = carta.querySelectorAll('.s-relato__carta-texto > p');
      if (!estrofas.length) return;

      var t = INICIO;
      estrofas.forEach(function (p) {
        var partes = p.innerHTML.split(/<br\s*\/?>/i);
        p.innerHTML = partes.map(function (parte) {
          var retraso = t.toFixed(2);
          t += PAUSA_VERSO;
          return '<span class="s-relato__verso" style="transition-delay:' + retraso + 's">' + parte + '</span>';
        }).join('');
        t += PAUSA_ESTROFA;
      });

      var despedida = carta.querySelector('.s-relato__carta-despedida');
      var firma = carta.querySelector('.s-relato__carta-firma');
      if (despedida) despedida.style.transitionDelay = t.toFixed(2) + 's';
      if (firma) firma.style.transitionDelay = (t + 0.3).toFixed(2) + 's';

      carta.classList.add('s-relato__carta--escribe');

      var observer = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          observer.disconnect();
          carta.classList.add('es-escrita');
        });
      }, { threshold: 0.4 });
      observer.observe(carta);
    });
  }

  iniciar();
  escribirCarta();
  document.addEventListener('shopify:section:load', function () {
    iniciar();
    escribirCarta();
  });
})();
